export { default } from "./TabLinks";
export type { Props as TabLinksProps } from "./TabLinks";
